
import { Component, Vue } from 'vue-property-decorator';
import { getJobList, getRecordList } from '@/api/cyclCheck';
import { UserModule } from '@/store/modules/user';
import dialogImgLarge from '@/components/ImgLarge/index.vue';

@Component({
  name: 'cycleCheckRecord',
  components: {
    dialogImgLarge
  }
})
export default class extends Vue {
private listQuery:any= {
  page: 1,
  size: 10,
  check_id: '',
  check_name: '',
  last_check_state: '',
  start_time: '',
  end_time: '',
  company_name: '',
  contain_branch: ''
}

   private listData={
     list: [],
     total: 0
   }
     private loading= false

      private stateOptions= [{
        value: '0',
        label: '未点检'
      }, {
        value: '1',
        label: '正常'
      }, {
        value: '2',
        label: '异常'
      }, {
        value: '9',
        label: '已点检'
      }]

      private checkJobDetailVisible= false
      private jobDetailMore=false
      private jobDetailQuery:any={
        page: 1,
        size: 10
      }
      private jobDetailData:any= []

      private activeDetailsName= 'first'

      created() {
        // if (CycleCheckRecordController.is_branch) {
        //   this.listQuery.is_branch = CycleCheckRecordController.is_branch;
        // }
        // if (CycleCheckRecordController.hasOwnProperty('last_check_state')) {
        //   this.listQuery.last_check_state = CycleCheckRecordController.last_check_state.toString();
        // }
        // if (CycleCheckRecordController.start_time) {
        //   this.listQuery.start_time = CycleCheckRecordController.start_time;
        //   this.listQuery.end_time = CycleCheckRecordController.end_time;
        // }
        this.getCheckJobList();
      }
      // 获取当日
      private getCheckJobList() {
        let _this = this;
        this.loading = true;
        this.listQuery.user_id = UserModule.getUserId;
        this.listQuery.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
        this.listQuery.check_id = this.$route.query.id;
        getJobList(this.listQuery).then(res => {
          if (res.data != null) {
            _this.listData.list = res.data.list;
            _this.listData.total = res.data.count;
          } else {
            _this.listData.list = [];
            _this.listData.total = 0;
          }
          _this.loading = false;
        }).catch(err => {
          let msg = err.msg;
        });
      }
      // 获取详情
      private getCheckJobDetail(item:any) {
        this.checkJobDetailVisible = true;
        this.jobDetailMore = false;
        let _this = this;
        if (this.listQuery.is_branch) {
          this.jobDetailQuery.branch_company_id = item.company_id;
        }
        this.jobDetailQuery.job_id = item.id;
        this.jobDetailQuery.user_id = UserModule.getUserId;
        this.jobDetailQuery.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
        getRecordList(this.jobDetailQuery).then(res => {
          if (res.data) {
            if (_this.jobDetailQuery.page === 1) {
              _this.jobDetailData = res.data.list;
            } else {
              if (res.data.list && res.data.list.length) {
                for (var i = 0; i < res.data.list.length; i++) {
                  _this.jobDetailData.push(res.data.list[i]);
                }
              }
            }
            // 是否 显示加载更多
            if (_this.jobDetailData.length < res.data.count) {
              _this.jobDetailMore = true;
            } else {
              _this.jobDetailMore = false;
            }
          } else {
            _this.jobDetailData = [];
          }
        }).catch(err => {
          let msg = err.msg;
        });
      }
      // 详情加载更多
      private moreJobDetailData() {
        this.jobDetailQuery.page += 1;
        let params = {
          id: this.jobDetailQuery.job_id,
          company_id: this.jobDetailQuery.branch_company_id
        };
        this.getCheckJobDetail(params);
      }

      private JobDetailClose() {
        this.jobDetailQuery.page = 1;
        this.checkJobDetailVisible = false;
      }
      // 播放 图片视频
      private handleMedia(val: [], index: number) {
        let value;
        if (typeof val === 'object') {
          value = val;
        } else {
          value = [{ video_url: val }];
        }
        let enlargedData = {
          isShow: true,
          imgList: value,
          initNum: index
        };
        this.$store.dispatch('toggleEnlarged', enlargedData);
      }
      // 搜索
      private search() {
        this.listQuery.page = 1;
        this.listData.list = [];
        this.listData.total = 0;
        this.getCheckJobList();
      }
      // 重置
      private clear() {
        this.listQuery.page = 1;
        this.listQuery.check_name = '';
        this.listQuery.last_check_state = '';
        this.listQuery.start_time = '';
        this.listQuery.end_time = '';
        this.listQuery.company_name = '';
        this.listQuery.contain_branch = '';
        this.getCheckJobList();
      }
      private handleSizeChange(size:number) {
        this.listQuery.size = size; // 每页下拉显示数据
        this.getCheckJobList();
      }
      private handleCurrentChange(page:number) {
        this.listQuery.page = page; // 点击第几页
        this.getCheckJobList();
      }
      private getCheckState(value:any) {
        let detail = '';
        switch (parseInt(value)) {
          case 0:
            detail = '未点检';
            break;
          case 1:
            detail = '正常';
            break;
          case 2:
            detail = '异常';
            break;
        }
        return detail;
      }
}
